import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Navigate } from 'react-router-dom';
// hooks
import useLanguage from '../hooks/useLanguage';
// routes
import { PATH_DASHBOARD } from '../routes/paths';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useSelector((state) => state.auth);
  const { getLocalizedPath } = useLanguage();

  if (isAuthenticated) {
    // Redirect to dashboard with language prefix
    return <Navigate to={getLocalizedPath(PATH_DASHBOARD.root)} />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
